import * as _ from 'lib/utilities';

const nativePaidPhase = product => {
    const offer = product && product.getOffer && product.getOffer();
    const pricingPhases = (offer && offer.pricingPhases) || [];
    const recurrenceMode = window.CdvPurchase && window.CdvPurchase.RecurrenceMode;
    const paidPriceMicros = phase => Number(phase.priceMicros || 0);

    return _.find(pricingPhases, phase => (
        paidPriceMicros(phase) > 0 &&
        (!recurrenceMode || phase.recurrenceMode === recurrenceMode.INFINITE_RECURRING)
    )) || _.find(pricingPhases, phase => paidPriceMicros(phase) > 0);
}

const formatCurrency = (amount, currency) => {
    return new Intl.NumberFormat(navigator.language, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol'
    }).format(amount);
}

const currencySymbol = currency => {
    const parts = new Intl.NumberFormat(navigator.language, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol'
    }).formatToParts(0);

    return (parts.find(part => part.type === 'currency') || {}).value || currency;
}

const intervalMonths = ({ intervalUnit, intervalCount }) => {
    const count = intervalCount || 1;

    if(intervalUnit === 'year') {
        return count * 12;
    } else if(intervalUnit === 'month') {
        return count;
    } else if(intervalUnit === 'week') {
        return count / (52 / 12);
    }

    return 1;
}

const comparisonInterval = catalog => ({
    intervalUnit: catalog.subscriptionGroup.comparisonIntervalUnit,
    intervalCount: catalog.subscriptionGroup.comparisonIntervalCount
});

const hydrateProductPrice = (catalogProduct, store, catalog) => {
    const externalId = catalogProduct.providerProduct && catalogProduct.providerProduct.externalId;
    const nativeProduct = externalId && store.get(externalId, _.getIapPlatform());
    const paidPhase = nativePaidPhase(nativeProduct);

    const priceMicros = Number((paidPhase && paidPhase.priceMicros) || 0);
    const currency = paidPhase && (paidPhase.currency || paidPhase.currencyCode);

    if(!priceMicros || !currency) {
        return catalogProduct;
    }

    const amount = priceMicros / 1000000;
    const comparisonAmount = Math.round((amount / intervalMonths(catalogProduct) * intervalMonths(comparisonInterval(catalog))) * 100) / 100;

    return {
        ...catalogProduct,
        price: {
            ...(catalogProduct.price || {}),
            amount,
            formattedAmount: paidPhase.price || formatCurrency(amount, currency),
            discount: null,
            discountAmount: null,
            formattedDiscountAmount: null,
            comparisonAmount,
            formattedComparisonAmount: formatCurrency(comparisonAmount, currency),
            discountComparisonAmount: null,
            formattedDiscountComparisonAmount: null,
            discountLength: null,
            discountLengthUnits: null,
            currency,
            currencySymbol: currencySymbol(currency)
        }
    };
}

export const hydrateNativeSubscriptionCatalog = catalog => {
    const store = _.getIapStore();

    if(!window.cordova || !store || !catalog || !catalog.products) {
        return catalog;
    }

    return {
        ...catalog,
        products: catalog.products.map(product => hydrateProductPrice(product, store, catalog))
    };
}

export const waitForIapStoreReady = () => {
    const store = _.getIapStore();

    if(!window.cordova || !store) {
        return Promise.resolve();
    }

    return new Promise(resolve => store.ready(resolve));
}
